import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import { type IPublicClientApplication } from '@azure/msal-browser';
import { labFlowApiRequest } from '@shared/auth/msal.config';
import { installAuthInterceptor } from '@interceptors/auth.interceptor';
import { installCorrelationIdInterceptor } from '@interceptors/correlation-id.interceptor';
import { environment } from '@environments/environment';

export type HttpClient = AxiosInstance;

type Options = {
  readonly baseURL?: string;
  readonly scopes?: readonly string[];
};

/**
 * Builds the shared `HttpClient` used by all `3.data` repositories.
 * The MSAL auth interceptor is wired in from
 * `@interceptors/auth.interceptor` — this file only handles
 * instance creation + defaults.
 */
export function createHttpClient(
  msalInstance: IPublicClientApplication,
  options: Options = {},
): HttpClient {
  const instance = axios.create({
    baseURL: options.baseURL ?? environment.labFlowApi.baseUrl,
    timeout: 30_000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  installAuthInterceptor(instance, msalInstance, {
    scopes: options.scopes ?? labFlowApiRequest.scopes,
  });

  installCorrelationIdInterceptor(instance);

  return instance;
}

export type { AxiosRequestConfig };
